import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import OrderEntry from "../menu/order-entry";

import PrivateRoute from "components/common/PrivateRoute";

const OrdersRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={OrderEntry}
            />
        </Switch>
    </div>
);

export default connect()(OrdersRouter);